import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { IonSpinner } from "@ionic/react";
import { isNativeiOS } from "../../lib/utils/platform";
import { isEmbroideryTrace } from "../../config/appVariant";
import Checkout from "../Checkout";

export default function PrivateRoute({ component: Component, ...rest }) {
  const { user, userIsPremium, userIsEmbroideryPremium, isLoading } = useAuth();

  const embroideryStatusLoading = isEmbroideryTrace && user && userIsEmbroideryPremium === null;

  if (isLoading || embroideryStatusLoading) {
    return (
      <Route
        {...rest}
        render={() => (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: '#1e293b',
          }}>
            <IonSpinner name="crescent" />
          </div>
        )}
      />
    );
  }

  const hasAccess = isNativeiOS() || (isEmbroideryTrace ? userIsEmbroideryPremium : userIsPremium);

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          hasAccess ? (
            <Component {...props} />
          ) : (
            <Checkout />
          )
        ) : (
          <Redirect to="/signin" />
        )
      }
    />
  );
}
